import PatientOverviewKnowledgeTimeline from 'dashboard/templates/views/Patient/Knowledge/PatientOverviewKnowledgeTimeline';

export default {
  path: 'timeline',
  name: 'PatientRecordKnowledgeTimeline',
  component: PatientOverviewKnowledgeTimeline,
  meta: {
    // title: 'Patient Record - Knowledge - Timeline',
    //title: t => `${t('patient.patientRecord')} - ${t('screens.increaseYourKnowledgeSettingScreen', 'app_mobile')} - ${t('timeline')}`,
    // title: 'Increase your Knowledge - Timeline',
    title: t => `${t('screens.increaseYourKnowledgeSettingScreen', 'app_mobile')} - ${t('timeline')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true,
  }
};
